export default __webpack_public_path__ + "static/piplup-79741c96d9b1e099d72d70fb480e2d1b.webp";